import { render, staticRenderFns } from "./Kickoff.vue?vue&type=template&id=1cd369a9&"
import script from "./Kickoff.vue?vue&type=script&lang=js&"
export * from "./Kickoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports